import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type React from 'react';

const StyledContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  marginTop: theme.spacing(0.75),
  marginLeft: theme.spacing(3),
  borderRadius: '27px',
  padding: theme.spacing(0.5),
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(1.5),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));

const StyledDiv = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.secondary.extraLowContrast,
  borderRadius: '27px',
  paddingTop: theme.spacing(0.5),
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(0.5),
  paddingLeft: theme.spacing(2),
}));

const StyledHeader = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(0.25),
}));

const StyledMessage = styled(Typography)(({ theme }) => ({
  margin: 0,
  color: theme.palette.secondary.body,
}));

type ServiceUnavailableProps = {
  headerText: string;
  message: string;
};

export const ServiceUnavailable: React.FC<ServiceUnavailableProps> = ({
  headerText,
  message,
}) => (
  <StyledContainer>
    <StyledDiv>
      <StyledHeader variant="finePrint2Medium" paragraph>
        {headerText}
      </StyledHeader>
      <StyledMessage variant="finePrint2" paragraph>
        {message}
      </StyledMessage>
    </StyledDiv>
  </StyledContainer>
);
